module.exports = __webpack_public_path__ + "static/img/40016 (2).8043fb1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40016 (2).webp
// module id = DSXP
// module chunks = 14